import React from 'react'
import PropTypes from 'prop-types'
import I18n from 'translations/i18n'
import { Text } from '@jisr-hr/design-system'

import Record from '../Record'

const Deductable = ({ data }) => (
  <Record
    title={I18n.t('deductable')}
    label={<DeductableText value={data.from} />}
    value={<DeductableText value={data.to} />}
  />
)

const DeductableText = ({ value }) => {
  const color = value > 0 ? 'feedback-error-dark-new' : 'natural-black-default'
  const minutes = value ? `${value} ${I18n.t('min')}` : 0

  return (
    <Text
      typography="paragraph16"
      color={`var(--color-${color})`}
      style={{ fontWeight: 700 }}
    >
      {minutes || '--'}
    </Text>
  )
}

DeductableText.propTypes = {
  value: PropTypes.string,
}

Deductable.propTypes = {
  data: PropTypes.shape(),
}

export default Deductable
